export default __webpack_public_path__ + "static/media/Home_News_thmb.29f83909.png";